import { AdvAccount } from '~/lib/types/AdvAccount'
import { BackendApiRequest, BackendApiRequestWithFirebaseAuth } from '../client'

export const getAdvAccount = async () => {
  const { advAccount } = await BackendApiRequest<{ advAccount: AdvAccount }>({
    url: '/v1/adv_accounts/me',
  })
  return advAccount
}

export type CreateAdvAccountProps = {
  companyName: string
  companyNameFurigana: string
  companyUrl: string
  representativeName: string
  postalcode?: string
  pref?: number
  city?: string
  address1?: string
  address2?: string
}

export const createAdvAccount = async (data: CreateAdvAccountProps) => {
  const { advAccount } = await BackendApiRequestWithFirebaseAuth<{ advAccount: AdvAccount }>({
    method: 'POST',
    url: '/v1/adv_accounts',
    data: data,
  })
  return advAccount
}

export const updateAdvAccount = async (
  advId: number,
  data: Partial<
    Pick<
      AdvAccount,
      | 'companyName'
      | 'companyNameFurigana'
      | 'representativeName'
      | 'companyUrl'
      | 'postalcode'
      | 'city'
      | 'address1'
      | 'address2'
    > & { pref: number | null }
  >,
) => {
  // on server-side, user adv info is fetch from firebase
  const { advAccount } = await BackendApiRequest<{ advAccount: AdvAccount }>({
    method: 'PATCH',
    url: `/v1/adv_accounts/${advId}`,
    data: {
      adv_account: data,
    },
  })
  return advAccount
}
